<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="오늘 아웃링크 전환 내역"
      desc="오늘 파트너의 상품으로 링크 전환한 내역입니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="is_user" slot-scope="props">
        <div v-if="props.item.is_user">회원</div>
        <div v-else>비회원</div>
      </div>

      <div slot="product_name" slot-scope="props">
        {{ props.item.product.name }}
      </div>

      <div slot="img" slot-scope="props"
           style="text-align: center; display: inline-block"
           :style="imgField(props.item.product.img)">
      </div>

      <div slot="link" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <a :href="props.item.product.link" target="_blank">링크</a>
      </div>

      <div slot="is_success" slot-scope="props">
        <div v-if="props.item.is_success">성공</div>
        <div v-else>실페</div>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import moment from 'moment'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpModal from '../../module/common/LpModal.vue'


  export default {

    mixins: [
      ListMixin
    ],

    components: {
      LpSortDropDown, LpInputText, LpRadio,
      LpModal
    },
    created() {
      this.init();

    },
    data () {
      return {}
    },
    methods: {
      init () {
        this.initializing('outlink', 'outlink/product');
        this.filtered.start =  moment().format('YYYY-MM-DD');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'

  .tr-whole-border th
    padding 12px 6px
  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem
  .btn-confirm-new-req
    background-color #ffb100
    color #fff
  .btn-stand-by-ests
    color #064160
    font-weight bold
  .btn-write-sheet
    background-color $primary
    color #fff

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e
</style>
